<template>
  <section class="premium-box">
    <h3>Premium</h3>
    <!--    <div class="flex-sb">-->
    <!--      <div class="form-half">-->
    <div class="box ">
      <div class="">
        <el-form
          ref="premiumForm"
          :model="formData"
          :rules="rules">
          <div class="table">
            <div
              class="tr style-1">
              <span> Basic Premium</span>
              <div class="flex flex-algin right">
                <span class="">
                  <el-form-item
                    ref="basic_prm"
                    prop="basic_prm">
                    <v-input
                      v-model="formData.basic_prm"
                      prepend="$"
                      :keyFloatNumber="true"
                      maxlength="8"
                      @blur="handlerComputed"
                    />
                  </el-form-item>
                </span>
              </div>
            </div>
            <div
              class="tr style-1">
              <span> EC Levy</span>
              <div class="flex flex-algin right">
                <span class="">
                  <el-form-item>
                    <v-input
                      v-model.number="formData.ec_levy_vl"
                      prepend="$"
                      :keyFloatNumber="true"
                      maxlength="8"
                      @blur="handlerComputed"
                    />
                  </el-form-item>
                </span>
              </div>
            </div>
            <div
              class="tr style-1">
              <span> IA Levy</span>
              <div class="flex flex-algin right">
                <span class="">
                  <el-form-item>
                    <v-input
                      v-model.number="formData.ia_levy_vl"
                      prepend="$"
                      :keyFloatNumber="true"
                      maxlength="8"
                      @blur="handlerComputed"
                    />
                  </el-form-item>
                </span>
              </div>
            </div>
            <div
              class="tr">
              <span>Premium</span>
              <span class="right">{{formData.premium | formatMoney(2, true)}}</span>
            </div>
            <div
              v-if="code_disc_prm"
              class="tr">
              <!--              <span>MGM Discount {{ formData.code_disc_pct }}%</span>-->
              <span>MGM Discount</span>
              <!--              <span class="right">- {{formData.code_disc_prm| formatMoney(2, true)}}</span>-->
              <el-form-item
                ref="code_disc_prm"
                prop="code_disc_prm">
                <span>
                  <v-input
                    v-model.number="formData.code_disc_prm"
                    prepend="$"
                    :keyFloatNumber="true"
                    maxlength="8"
                    :min="0"
                    @blur="handlerComputed"></v-input>
                </span>
              </el-form-item>
            </div>
            <div
              v-if="formData.coupon_code"
              class="tr">
              <span>Coupon:{{formData.coupon_code}}</span>
              <el-form-item
                ref="coupon_vl"
                prop="coupon_vl">
                <span>
                  <v-input
                    v-model.number="formData.coupon_vl"
                    prepend="-$"
                    :keyFloatNumber="true"
                    maxlength="8"
                    :min="0"
                    @blur="handlerComputed"></v-input>
                </span>
              </el-form-item>
            </div>


            <div  class="tr">
              <span>Manual Discount </span>
              <el-form-item
                ref="spec_disc_prm"
                prop="spec_disc_prm">
                <span>
                  <v-input
                    v-model.number="formData.spec_disc_prm"
                    prepend="-$"
                    :keyFloatNumber="true"
                    maxlength="8"
                    :min="0"
                    @blur="handlerComputed"></v-input>
                </span>
              </el-form-item>
            </div>
            <div  class="tr">
              <span>Admin Charge </span>
              <el-form-item
                ref="handling_fee"
                prop="handling_fee">
                <span>
                  <v-input
                    v-model.number="formData.handling_fee"
                    prepend="+$"
                    :keyFloatNumber="true"
                    maxlength="8"
                    :min="0"
                    @blur="handlerComputed"></v-input>
                </span>
              </el-form-item>
            </div>
            <div  class="tr style-4">
              <span>Paid Amount</span>
              <span class="right span-right">
                {{ formData.amount | formatMoney(2, true) }}
              </span>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <!--    <div-->
    <!--      v-if="!isEdit && !formData.coupon_code && !formData.promo_code"-->
    <!--      class="code-select-button">-->
    <!--      <div-->
    <!--        class="flex">-->
    <!--        <v-button-->
    <!--          plain-->
    <!--          @click="handlerClickCode(1)">Coupon Code</v-button>-->
    <!--        <v-button-->
    <!--          plain-->
    <!--          class="margin-button"-->
    <!--          @click="handlerClickCode(2)">Referral Code</v-button>-->
    <!--      </div>-->
    <!--    </div>-->
    <template>
      <div class="coupon-body marigin-bottom">
        <div v-if="!formData.coupon_code">
          <span class="coupon-title">Coupon Code</span>
          <v-input
            v-model="coupon_code"
            append="Apply"
            :maxlength="20"
            :uppercase="true"
            :keyNonChinese="true"
            @handlerAppend="handlerCouponAppend"></v-input>
        </div>
        <div
          v-if="formData.coupon_code"
          class="flex flex-sb">
          <span class="coupon-title">{{'Coupon Code: '+formData.coupon_code}}</span>
          <v-button
            plain

            @click="handlerDelete(1)">
            <font-awesome-icon
              icon="trash-alt"></font-awesome-icon>
          </v-button>
        </div>
      </div>



    </template>
    <div
      class="coupon-body">
      <div v-if="!formData.promo_code">
        <span class="coupon-title">Referral Code</span>
        <v-input
          v-model="code"
          append="Apply"
          :maxlength="20"
          :uppercase="true"
          :keyNonChinese="true"
          @handlerAppend="handlerAppend"></v-input>
      </div>
      <div
        v-if="formData.promo_code"
        class="flex flex-sb">
        <span class="coupon-title">{{'Referral Code: '+formData.promo_code}}</span>
        <v-button
          plain

          @click="handlerDelete(2)">
          <font-awesome-icon
            icon="trash-alt"></font-awesome-icon>
        </v-button>
      </div>
    </div>
  </section>
</template>

<script>
import MixinFormat from '@/mixins/format'
import {applyOrderCode} from '@api/order'
import {getReferralMain} from '@api/refer'
import MixinRules from '@/mixins/rules'
import {mapState} from 'vuex'

import {getManualPremiumResult} from '@/api/ticket'
import {replySmeCoupon} from '@/api/coupon'

export default {
  name: 'business-premium-form',
  components:{
    // premiumSelectCode
  },
  mixins:  [MixinFormat,MixinRules],
  props:{
    customerId:{
      type:[Number,String],
      default:''
    },
    form: {
      type: Object,
      default: () => ({})
    },
    quoteId: {
      type: [String, Number],
      default: ''
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return{
      premium:[],
      codeNumber:'',
      code:'',
      coupon_code: '',
      code_disc_prm:'',
      formData:{
        handling_fee:0,
        spec_disc_prm:0,
        // promo_disc_prm:'',
        coupon_vl:'',
        coupon_code:'',
        code_disc_prm:0,
        code:'',
        code_disc_pct:'',
        basic_prm:0,
        // base_prm:'',
        // loading_base_pct:'',
        payable:'',
        mib_vl:'',
        ia_levy_vl: 0,
        ec_levy_vl: 0,
        promo_code: '',
        premium: '',
        amount: ''
      }
    }
  },
  computed:{
    ...mapState('coupon', ['couponCode','selectCode']),
    customer(){
      let {isrd_nm} = this.form||{}
      return {
        isrd_nm
      }
    },
  },
  watch:{
    form:{
      immediate: true,
      handler(val) {
        if (val) {
          Object.keys(this.formData).some(key => {
            if (key in val) {
              this.formData[key] = val[key]
            }
          })
          if(val.coupon_code) {
            // this.codeNumber = 1
          }
          if(val.promo_code) {
            this.code_disc_prm = true
          }
        }
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs['premiumForm'].validate((valid, rules) => {
        if(valid) {
          this.$emit('submitPremium','premium', this.formData)
        }
        else {
          this.scrollToValidDom(rules)
        }
        // this.network().getReferralMain({},formName)
      })
    },
    handlerReferral() {
      this.isReferral = true
    },
    handlerClickCode(code){
      this.codeNumber = code
    },
    handlerComputed(){
      this.$refs['premiumForm'].validate((valid, rules) => {
        if(valid) {
          this.network().getManualPremiumResult()
        }
      })
    },
    handlerCouponAppend() {
      this.network().replySmeCoupon({coupon_code:this.coupon_code, insurance_type: this.form.insurance_type,order_id:this.orderId})
    },
    handlerAppend(num){
      // if(this.codeNumber==1)
      //   this.formData.coupon_code = this.code
      // else this.network().applyOrderCode()

      this.formData.promo_code = this.code
      this.handlerComputed()
    },
    handlerDelete(num){
      if(num==1) {
        this.coupon_code = ''
        this.formData.coupon_code = ''
      }
      if(num==2)
      {
        this.formData.promo_code = ''
        this.code = ''
        this.code_disc_prm = false
      }
      this.handlerComputed()
    },
    applyCode(){
      this.network().getReferralMain()
    },
    network() {
      return {
        getReferralMain:async (params,formName)=>{
          let {refer_id,trm_of_cvr,company_id,plan_id,benefits} = this.form
          // let {selectCode,coupon_code,code} = this.selectCode||{}
          // if(selectCode==1){
          //   this.formData.coupon_code = coupon_code
          //   this.formData.code = ''
          // }
          // else if(selectCode==2){
          //   this.formData.code = code
          //   this.formData.coupon_code =''
          // }else if(!selectCode){
          //   this.formData.code = ''
          //   this.formData.coupon_code =''
          // }
          const {data} = await  getReferralMain({
            refer_id,
            trm_of_cvr,
            company_id,
            plan_id,
            benefits,
            class_id:this.classId,
            ...this.formData,
            ...params
          })
          Object.assign(this.formData,data)
          Object.keys(this.formData).some(key => {
            if (key in data) {
              this.formData[key] = data[key]
            }
          })
          // this.$emit('submitPremium',formName, this.formData)
          this.$emit('getSubmitPremium',this.formData)
        },
        applyOrderCode: async () => {
          const { data } = await applyOrderCode({
            order_id: this.orderId,
            customer_id: this.customerId,
            code:this.code
          })
          this.formData.code = this.code
          // this.formData = Object.assign(this.formData, dataCode)
        },
        replySmeCoupon: async (params) => {
          const { data } = await replySmeCoupon(params)
          // this.formData.code = this.code
          this.formData.coupon_code = this.coupon_code
          this.handlerComputed()
          // this.formData = Object.assign(this.formData, dataCode)
        },
        getManualPremiumResult: async () => {
          let params = {
            manual_quote_id: this.quoteId,
            ...this.formData
          }
          this.formData.promo_code = ''
          if(this.orderId) {
            params.order_id = this.orderId
          }
          if(!this.formData.coupon_code) {
            delete params.coupon_vl
          }
          params.code = params.promo_code
          delete params.promo_code
          const { data } = await getManualPremiumResult(params)
          data.code_disc_prm = this.formData.code_disc_prm
          this.code_disc_prm =params.code?true:false
          this.formData = {
            ...this.formData,
            ...data,
            promo_code:params.code
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.premium-box{
  width: 345px;
  //width: 500px;
  margin-bottom: 24px;
  padding-bottom: 100px;
  .box{
    box-sizing: border-box;
    width:100%;
    border: 1px solid #E1E4E8;
    border-radius: 8px;
    background-color: #FFFFFF;
    .table{
      margin-bottom: 0;
      .tr{
        //padding: 16px;
        height: 64px;
        padding: 0 16px;
        color: #586069;
        font-family: Inter;
        font-size: 14px;
        font-weight: 600;
        align-items: center;
        justify-content: space-between;
        &:last-child{
          border-bottom: 0;
        }
        >span{
          flex: 2;
          max-width: 50%;
          word-break: break-all;
        }
        >div{
          flex:2
        }
      }
      .tr:nth-child(2n){
        background: none;
      }
      .style-1{

      }
      .style-2{
        ::v-deep .el-input{
          width: 100px;
        }
      }
      .style-3{

      }
      .style-4{
        background-color: #F6F8FA!important;
        .span-right{
          color: #24292E;
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          letter-spacing: 0;
          line-height: 16px;
        }
      }
      .right{
        text-align: right;
        margin-left: 16px;
        //width: 80px;
      }
      .right-width{
        width: 69px;
      }
      .flex-algin{
        align-items: center;
        justify-content: flex-end;
      }
    }

  }
  ::v-deep .el-input-group__append{
    padding: 0 5px;
  }
  .code-select-button {
    margin-top:15px;
    .flex{
      align-items: center;
      .el-button:first-child{
        margin-bottom: 0;
        margin-right: 5px;
      }
    }
    ::v-deep .el-button {
      width: 100%;
      border-radius: 4px;
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      font-weight: 500;
      //margin-bottom: 16px;
    }
    .margin-button{
      margin-bottom: 0!important;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
    .icon-left{
      color: #1d43a0;
      margin-right: 8px;
    }
    .hand{
      cursor:pointer
    }
  }
  .coupon-body{
    margin-top:15px;
  }
  .marigin-bottom{
    padding-bottom: 15px;
    border-bottom: 1px solid #E1E4E8;
  }
  .coupon-title{
    color:#24292E;
    font-size:16px!important;
    font-weight: 600;
    text-overflow: ellipsis;
    word-break: break-word;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
}
</style>
